import {GROWTHBOOK_EVENTS} from '../../growthbook/constants';

const handleGrowthBookUpdateEvent = callback => {
  document.addEventListener(GROWTHBOOK_EVENTS.LOAD, event => {
    callback(event.detail.growthBook);
  });
};

export {handleGrowthBookUpdateEvent};
